<template>
  <el-dialog title="提示" :visible.sync="visible" center class="drugValidDialog__outer">
    <div class="content">
      <div class="text">药品信息不正确，错误内容为：{{ errorReason }}</div>
      <div class="text">如选择本次忽略，则仅供本次申请处方使用，不添加公司药品库。</div>
    </div>
    <span slot="footer">
      <el-button type="primary" @click="onCancel">返回修改</el-button>
      <el-button type="primary" plain @click="onConfirm">确认正确，本次忽略</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'drugValidDialog',
  data() {
    return {
      visible: false,
      resolve: undefined,
      errorReason: ''
    };
  },
  methods: {
    $show() {
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.visible = true;
      });
    },
    _reset() {
      this.visible = false;
    },
    onCancel() {
      this._reset();
      this.resolve && this.resolve(false);
    },
    onConfirm() {
      this._reset();
      this.resolve && this.resolve(true);
    }
  }
};
</script>

<style lang="scss">
.drugValidDialog__outer {
  .content {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #242424;
  }
  .text {
    margin-top: 12px;
  }
}
</style>
